import { timeSeriesChildColumnListData } from "../cellComponents/FushionColumn/constants/MdvConstant";
import { Cell, ColumnsFromDB, Row } from "../interfaces/gridInterfaces";
import { gridRowChanges } from "../redux/action/gridAction";
import xTablesStore from "../redux/xTablesStore";
import { ParsedData } from "./MdvHelper";
import { checkIfAllPropValuesEmpty, checkIfAvgRollUpFieldExistsAndUpdate, predecessorCellValidation, updateMDVRollUpValue,
     updatePredecessorAndSuccessorRows } from "./helperFunctions";
import { addTimes, recursivelyCalculateParentTillTop, removeEleFromStringWithCommaAsDelimiter, valueGetterForTotalTimeSeriesColumn } from "./helpersSubModule";


export const isTimeSeriesPresent = (columns:ColumnsFromDB[]):number=>{
    let isTimeSeriesPresent = -1
    for(let i = 0;i<columns.length ; i++){
        let col=columns[i]
        if(col.block && !col.parent){
            try {
                let rangeInfo = JSON.parse(col.block);
                if (rangeInfo.startDate && rangeInfo.endDate) {
                    isTimeSeriesPresent = i;
                    break;
                }
            }
            catch (err) {
                console.warn('not block', err);
            }
          
        }
    }
    return isTimeSeriesPresent
}
export const changeUpdatedDateOfRow = (row:Row,user_email:string):Row=>{
    let updatedRow = {...row}
    updatedRow.updated_date = new Date().toISOString()
    updatedRow.lastUpdatedBy = user_email
    return updatedRow
}
export const updateCellValue = (row: Row | Object, col: string, fieldToUpdate: string, newValue: string | undefined, user_email: string): Cell => {
    if (!col.includes("_es")) {col = col+"_es"}
    let cell: Cell & { prev_val?: Array<{ value: string | undefined; updatedDate?: string, updatedBy?: string }> } = row[col];
    if (cell && typeof cell === 'object') {
        if (!cell.prev_val) {
            cell.prev_val = [];
        }
        if ((cell[fieldToUpdate] ?? '').toString().trim() !== newValue?.toString().trim()) {
            if (typeof newValue === 'object' && newValue !== null) {
                newValue = JSON.stringify(newValue);
            }
            if (typeof cell.value === 'object' && cell.value !== null) {
                cell.value = JSON.stringify(cell.value);
            }
            const newEntry: any = {
                value: cell.value,
                ...(cell.updatedDate && { updatedDate: cell.updatedDate }),
                ...(cell.lastUpdatedBy && { updatedBy: cell.lastUpdatedBy })
            };

            let currentEntry = {
                value: newValue,
                updatedDate: new Date().toUTCString(),
                updatedBy: user_email
            };

            if (cell.prev_val.length > 0) {
                let lastEntry = cell.prev_val[cell.prev_val.length - 1];
                let lastUpdatedTime = lastEntry.updatedDate ? new Date(lastEntry.updatedDate).getTime() : 0;
                let newUpdatedTime = cell.updatedDate ? new Date(cell.updatedDate).getTime() : 0;
                // Check if the time difference is less than 0.5 second to avoid unnecessary update of data
                if (newUpdatedTime - lastUpdatedTime < 500 && cell.prev_val[cell.prev_val.length - 1].value == cell.value || (cell.value == undefined && cell.prev_val[cell.prev_val.length - 1].value == "")) {
                    cell.prev_val.pop(); // Remove the last entry
                }
            }
            cell.prev_val.push(newEntry);
            cell.prev_val.push(currentEntry);

            // Keep only the last 5 records
            // if (cell.prev_val.length > 5) {
            //     cell.prev_val.shift(); // Remove the oldest entry
            // }
            cell.updatedDate = new Date().toUTCString()
            row['updated_date'] = new Date().toISOString()
            row['lastUpdatedBy'] = user_email
            cell.lastUpdatedBy = user_email
        }
        if (!row['lastUpdatedBy']) row['lastUpdatedBy'] = user_email
        if (!cell.lastUpdatedBy) cell.lastUpdatedBy = user_email
        cell[fieldToUpdate] = newValue
        return cell
    }
    else {
        cell = {
            value: newValue,
            "attachments": [],
            notes: "",
            format: '',
            cellStyle: {},
        }
        if (newValue) {
            cell.updatedDate = new Date().toUTCString();
            cell.lastUpdatedBy = user_email;
            row['updated_date'] = new Date().toISOString();
            row['lastUpdatedBy'] = user_email;
            let newEntry = {
                value: newValue,
                updatedDate: cell.updatedDate,
                updatedBy: cell.lastUpdatedBy
            };
            if (!cell.prev_val) {
                cell.prev_val= [newEntry];
            }


        }
        if (!row['lastUpdatedBy']) row['lastUpdatedBy'] = user_email;
        return cell
    }
}

interface RowData {
    id: string;
    predecessorNodes: string;
    successorNodes: string;
    [key: string]: any;
  }
  
  interface GridRef {
    current:{
        api: {
            getRowNode: (id: string) => { data: RowData } | null;
          };
    }
    
  }
  
  interface ColDef {
    colDef: {
      field: string;
    };
  }
  
export const removeExistingPredecessorsAndApplyNewOnes = (
    predecessorIdValueObj: Record<string, string>,
    gridRef: GridRef,
    rows: RowData[],
    predecessorColumnField: ColDef,
    startCol: ColDef,
    endCol: ColDef
): { rowsToUpdate: RowData[], undoRowsBeforePredecessorsChange: RowData[]}  => {
    const ids = Object.keys(predecessorIdValueObj).map((id) => id)
    const rowsToUpdate: RowData[] = [];
    const rowObj: { [id: string]: RowData } = {};
    const loggedInUser = xTablesStore.getState().gridReducer.loggedInUser;
    const undoRowsBeforePredecessorsChange: RowData[] = [];
    for (const element of ids) {
        const id = element;
        const rowToUpdate = rowObj[id] || gridRef.current.api.getRowNode(id)?.data;
        if (rowToUpdate) {
            const predecessors = rowToUpdate.predecessorNodes;
            if (predecessors) {
                predecessors.split(',').forEach((predecessor) => {
                    
                    const predecessorRow = rowObj[predecessor] || gridRef.current.api.getRowNode(predecessor)?.data;
                    undoRowsBeforePredecessorsChange.push({ ...predecessorRow });
                    if (predecessorRow) {
                        predecessorRow.successorNodes = removeEleFromStringWithCommaAsDelimiter(predecessorRow.successorNodes, rowToUpdate.id);
                        rowObj[predecessorRow.id] = predecessorRow;
                    }
                });
            }
            rowToUpdate.predecessorNodes = '';
            rowToUpdate[predecessorColumnField.colDef.field] = ''
            rowToUpdate[predecessorColumnField.colDef.field + '_es'] = updateCellValue(rowToUpdate, predecessorColumnField.colDef.field + '_es', "value", '', loggedInUser)
            rowObj[rowToUpdate.id] = rowToUpdate;
        }
    }
    const rowsToModify = rows.filter((row) => ids.includes(row.id));

    rowsToModify.forEach((row) => {
        const newPredecessor = predecessorIdValueObj[row.id];
        if (newPredecessor) {
            const response = updatePredecessorAndSuccessorRows(predecessorColumnField, row.data, gridRef.current, newPredecessor, '', rowObj);
            let predecessorRows = response && response.predecessorRows
            if (predecessorRows && predecessorRows.length > 0) {
                predecessorRows.forEach((predecessorRow) => {
                 if(predecessorRow)   
                    rowObj[predecessorRow.id] = predecessorRow;
                });
            }
            let currentRow = response && response.currentRow
            if (currentRow) {
                currentRow[predecessorColumnField.colDef.field] = newPredecessor
                currentRow[predecessorColumnField.colDef.field + '_es'] = updateCellValue(currentRow, predecessorColumnField.colDef.field + '_es', "value", newPredecessor, loggedInUser)
                let { formattedDate, validatedPredecessorValue, updatedRow } = predecessorCellValidation('', row.data, newPredecessor, '', startCol, endCol, gridRef)
                rowObj[currentRow.id] = updatedRow;
            }
        }
    });

    Object.keys(rowObj).forEach((id) => {
        rowsToUpdate.push(rowObj[id]);
    });

    return { rowsToUpdate, undoRowsBeforePredecessorsChange };
};
  
export const findAllRollupColumns = (columns:ColumnsFromDB[],columnsWithRollup:ColumnsFromDB[]=[]) => {
    for (const column of columns) {   
           
        // Check if the column has children and recursively search them
        if (column.children && column.children.length > 0) {
            findAllRollupColumns(column.children, columnsWithRollup);
        }
        else{
            if (column.rollup) {
                if((column.type === "date"&& (column.rollup === "Max" || column.rollup === "Min")) || (column.type === "number"&& (column.rollup === "Max" || column.rollup === "Min" || column.rollup === "Sum" || column.rollup === "Avg")))
                columnsWithRollup.push(column);
                else if(column.status || column.type ==='shareableRollupList') {
                    const statusRollupInfo = xTablesStore.getState().gridReducer.statusColumnRollupInfo
                    columnsWithRollup.push({...column,statusRollupInfo:statusRollupInfo});
                }
            }
            else if(column.block === 'timeseries')  columnsWithRollup.push(column);
            else if(column.status || column.type ==='shareableRollupList') {
                const statusRollupInfo = xTablesStore.getState().gridReducer.statusColumnRollupInfo
                columnsWithRollup.push({...column,statusRollupInfo:statusRollupInfo});
            }else if(column.type === "multi dimensional value" && checkIfRollupEnabledInMDV(column?.listData)){
                const statusRollupInfo = xTablesStore.getState().gridReducer.statusColumnRollupInfo
                columnsWithRollup.push({...column,statusRollupInfo:statusRollupInfo});
            }
        }
    }
    return columnsWithRollup;
};
export const getRolledUpValueForTimeSeriesCell = (values: string[]): string => {

    let  rollupValue: ParsedData[] = JSON.parse(JSON.stringify(timeSeriesChildColumnListData));
    const results: {
        plannedTotalTime: number,
        actualTotalTime: number,
    } = {
        plannedTotalTime: 0,
        actualTotalTime: 0,
    };
    let isPlannedTimeZeroByUser: boolean = false
    let isActualTimeZeroByUser: boolean = false

    values.forEach((cellValue) => {
        let parsedCellValue: ParsedData[] = typeof cellValue === 'string' ? JSON.parse(cellValue) : cellValue;
        parsedCellValue.forEach(({ propName, propValue }: { propName: string, propValue: string | number }) => {
            if (propValue != '') {
                if (propName === 'Planned Time') {
                    results.plannedTotalTime = addTimes(results.plannedTotalTime, propValue);
                    isPlannedTimeZeroByUser = propValue === '0' ? true : false
                    if (isPlannedTimeZeroByUser !== true && isPlannedTimeZeroByUser !== undefined && results.plannedTotalTime === 0) {
                        isPlannedTimeZeroByUser = true
                    }
                } else if (propName === 'Actual Time') {
                    results.actualTotalTime = addTimes(results.actualTotalTime, propValue);
                    isActualTimeZeroByUser = propValue === '0' ? true : false
                    if (isActualTimeZeroByUser !== true && isActualTimeZeroByUser !== undefined && results.actualTotalTime === 0) {
                        isActualTimeZeroByUser = true
                    }
                }
            }
        });
    });
    rollupValue[0].propValue = results.plannedTotalTime !== 0 ? results.plannedTotalTime : isPlannedTimeZeroByUser ? '0' : '';
    rollupValue[1].propValue = results.actualTotalTime !== 0 ? results.actualTotalTime : isActualTimeZeroByUser ? '0' : '';
    // Filter out TaskEnded if propValue is empty or "No"
    rollupValue = rollupValue.filter(
        (item) => !((item.propName === "TaskEnded" && (!item.propValue || item.propValue === "No"))|| item.propName === "Reason")
    );

    // Convert the filtered data back to a JSON string
    return JSON.stringify(rollupValue);
}

export const getRolledUpValueForMDV = (values: string[], listData : any[]) : string => {
try {
    if(typeof listData === 'string'){
        listData = JSON.parse(listData);
    }
    
    const rollupFields = returnRollUpFields(JSON.parse(JSON.stringify(listData)));
    values.forEach((cellValue) => {
        let parsedCellValue: ParsedData[] = typeof cellValue === 'string' ? JSON.parse(cellValue) : cellValue;
        let rowRollUpFields = returnRollUpFields(parsedCellValue);
        rowRollUpFields.filter((entity)=> entity.propValue).map((entity) => {
            let objToUpDate = rollupFields.find((field) => field.propId === entity.propId);
            updateMDVRollUpValue(objToUpDate, entity)
         })
    })

    checkIfAvgRollUpFieldExistsAndUpdate(rollupFields);

    return JSON.stringify(rollupFields);

} catch (error) {
    console.error("Error in getRolledUpValueForMDV", error);
    return JSON.stringify([]);
    
}
}

function getStartOfDayIST(utcDateStr: string) {
    // Step 1: Convert UTC string to Date object without timezone shift
    let utcDate = new Date(utcDateStr).getTime(); // Get UTC timestamp

    // Step 2: Move UTC time **backward** by 5 hours 30 minutes
    let istAdjustedTime = utcDate - (5 * 60 + 30) * 60000; // Move backward to IST

    // Step 3: Convert the adjusted time back to a Date object
    let adjustedDate = new Date(istAdjustedTime);

    // Step 4: Extract the year, month, and day in IST (from adjusted Date)
    let year = adjustedDate.getUTCFullYear();
    let month = adjustedDate.getUTCMonth();
    let day = adjustedDate.getUTCDate();

    // Step 5: Create a new Date at 00:00:00 IST for the extracted IST date
    let startOfDayIST = new Date(year, month, day, 0, 0, 0);

    return startOfDayIST;
}

export const updateTotalIfValueIsChanged = (timeSeriesParentColumn: ColumnsFromDB, totalColumn: ColumnsFromDB, params: { node: any, colDef: any }, row: Row, column: any, loggedInUserEmail: string) => {
    const loggedInUser = loggedInUserEmail || xTablesStore.getState().gridReducer.loggedInUser
    if (timeSeriesParentColumn && totalColumn) {
        let block: { startDate: string, endDate: string } = timeSeriesParentColumn.block ? JSON.parse(timeSeriesParentColumn.block) : "";
        let start = new Date(block.startDate);
        let end = new Date(block.endDate);
        let deepCopyRow = JSON.stringify(row);
        let data = JSON.parse(deepCopyRow);
        if (totalColumn?.field && totalColumn?.field + '_es') {
            const fieldKey = totalColumn.field + '_es';
            const value = data?.[fieldKey]?.value;
          
            if (value) {
              try {
                data = JSON.parse(value);
              } catch (e) {
                console.error("Failed to parse JSON:", e);
                data = "";
              }
            }
          } else {
            console.warn("totalColumn.field is undefined");
          }
        // Filter out TaskEnded if propValue is empty or "No"
        if (Array.isArray(data)) {
            data = data?.filter(
                (item) => !(item?.propName === "TaskEnded" && (!item.propValue || item.propValue === "No"))
            );
        }
        if (row[totalColumn.field + '_es']?.value) {
            // Convert the updated data back to a string and update the deepCopyRow
            row[totalColumn.field + '_es'].value = JSON.stringify(data);
        }
        deepCopyRow=JSON.stringify(row);
        let dummyParams = { data: row, colDef: params.colDef };   
        let totalValue: number | string | undefined = valueGetterForTotalTimeSeriesColumn(dummyParams, start, end, totalColumn.field, totalColumn.listData)
        row[totalColumn.field] = totalValue;
        const parsedRow = JSON.parse(deepCopyRow);
        const targetKey = totalColumn.field + '_es';
        
        if (parsedRow[targetKey] && data !== undefined && data !== null) {
          parsedRow[targetKey].value = data;
        }
        
        if (data || !checkIfAllPropValuesEmpty(totalValue))
            row[totalColumn.field + '_es'] = updateCellValue(JSON.parse(deepCopyRow), totalColumn.field + '_es', "value", totalValue, loggedInUser)

        return { rowUpdatedWithTotal: row, totalColumn }
    }
    else {
        let mainParent = recursivelyCalculateParentTillTop(column)
        if (mainParent) {
            let totalColumn = mainParent.children[0]
            if (totalColumn) totalColumn = totalColumn.children[0].colDef
            if (totalColumn) {
                let parent = mainParent.colGroupDef
                let block: { startDate: string, endDate: string } = JSON.parse(parent.block);
                let start: Date = getStartOfDayIST(block.startDate);
                let end: Date = new Date(block.endDate);
                let deepCopyRow = JSON.stringify(row);
                let data = JSON.parse(deepCopyRow);
                data = data[totalColumn.field + '_es']?.value ? JSON.parse(data[totalColumn.field + '_es'].value) : "";
                // Filter out TaskEnded if propValue is empty or "No"
                if (data) {
                    data = data?.filter(
                        (item) => !((item.propName === "TaskEnded" && (!item.propValue || item.propValue === "No"))|| item.propName === "Reason")
                    );
                }

                let dummyParams = { node: params.node, data: row, colDef: params.colDef }
                let totalValue: number | string | undefined = valueGetterForTotalTimeSeriesColumn(dummyParams, start, end, totalColumn.field, totalColumn.listData)               
                row[totalColumn.field] = totalValue;
                //let value = JSON.parse(deepCopyRow)[totalColumn.field + '_es'].value
                if (data) JSON.parse(deepCopyRow)[totalColumn.field + '_es'].value = data ? data : JSON.parse(deepCopyRow)[totalColumn.field + '_es'].value;
                if (data || !checkIfAllPropValuesEmpty(totalValue))
                    row[totalColumn.field + '_es'] = updateCellValue(JSON.parse(deepCopyRow), totalColumn.field + '_es', "value", totalValue, loggedInUser)
                //row[totalColumn.field + '_es'] = updateCellValue(row, totalColumn.field + '_es', "value", totalValue, loggedInUser)
                return { rowUpdatedWithTotal: row, totalColumn }
            }

        }
    }

    return { rowUpdatedWithTotal: row, totalColumn: "" }
}


export const addNewPredecessors = (
    rows: any[], 
    gridRef, 
    predecessorColumn: { [key: string]: any }, 
    startCol: string, 
    endCol: string
): any[] => {
    let rowObj: { [key: string]: any } = {}; // Initialize rowObj as an empty object
    let rowsToUpdate: any[] = [];
    let predecessorColumnField =predecessorColumn.colDef.field
    rows.forEach((row) => {
        const newPredecessor = row[predecessorColumnField];
        if (newPredecessor) {
            const response = updatePredecessorAndSuccessorRows(predecessorColumn, row, gridRef.current, newPredecessor, '', rowObj);
            let predecessorRows = response && response.predecessorRows;
            if (predecessorRows && predecessorRows.length > 0) {
                predecessorRows.forEach((predecessorRow: any) => {
                    rowObj[predecessorRow.id] = predecessorRow;
                });
            }
            let currentRow = response && response.currentRow;
            if (currentRow) {
                currentRow[predecessorColumn.colDef.field] = newPredecessor;
                currentRow[predecessorColumn.colDef.field + '_es'] = updateCellValue(currentRow, predecessorColumn.colDef.field + '_es', "value", newPredecessor, '');
                let { formattedDate, validatedPredecessorValue, updatedRow } = predecessorCellValidation('', row, newPredecessor, '', startCol, endCol, gridRef);
                rowObj[currentRow.id] = updatedRow;
            }
        }
    });
    Object.keys(rowObj).forEach((id) => {
        rowsToUpdate.push(rowObj[id]);
    });

    return rowsToUpdate;
};


interface UndoData {
    action: 'transaction' | 'insertMultiple' | 'delete' | 'edit' | 'wrap';
    cellRows?: any[];
    addedRows?: any[];
    rowData?: any[];
    updatedRows?: any[];
    type?: string;
}

interface ChangedRows {
    add?: {addedRows:any[],belowNodeId:string};
    update?: any[];
    delete?: any[];
}

export const getChangedRowsFromUndoStack = (undoData: UndoData): ChangedRows => {
    if (!undoData[0]) return {}
    let undoRows = undoData[0]
    let action = undoData[0].action;
    switch (undoData[0].type) {
        case 'row': {
            switch (action) {
                case 'transaction': {
                    return { update: undoRows.cellRows };
                }
                case 'insertMultiple': {
                    return { add: { addedRows: undoRows.allRowsAdded, belowNodeId: undoRows.belowNodeId }, update: undoRows.updatedRows };
                }
                case 'InsertCopiedData': {
                    return { add: { addedRows: undoRows.allRowsAdded, belowNodeId: undoRows.belowNodeId ?? 'none' }, update: undoRows.updatedRows };
                }
                case 'delete': {
                    let rowsToUpdate = [
                        ...(undoRows.extraRowsForPredecessor || []),
                        ...(undoRows.rolledUpRows || [])
                    ];
                    return { delete: undoRows?.rowData?.map((row) => row.data), update: rowsToUpdate };
                }
                case 'edit': {
                    return { update: undoRows.rowData };
                }
                case 'wrap': {
                    return { update: undoRows.cellRows };
                }
                case 'drag': {
                    return { delete: undoRows.cellRows, add: { addedRows: undoRows.cellRows, belowNodeId: undoRows.belowNodeId }, update: undoRows.updatedRows };
                }
                case 'expand' : {
                    return { update: [{...undoRows.node.data,collapsed:!undoRows.expanded}] };
                }
                case 'bulkCollapse':
                case 'bulkExpand': {
                    return {
                        update: undoRows.node.map(node => ({
                            ...node.data,
                            collapsed: !undoRows.expanded
                        }))
                    };
                }
                default: {
                    return {};
                }
            }
        }
        case 'column': {
            switch (action) {
                case 'delete':
                case 'updateColumnProperties': {
                    if (undoRows.cellRows.length) {
                        return { update: undoRows.cellRows };
                    }
                    return {};
                }
                case 'wrap-toggle':{
                    return { update: undoRows.cellRows };
                }
                default: {
                    return {};
                }
            }
        }
        default: {
            return {}; // Return an empty object if type doesn't match
        }

    }
};

export const getChangedRowsFromRedoStack = (redoData: UndoData): ChangedRows => {
    if (!redoData[0]) return {}
    let redoRows = redoData[0]
    let action = redoData[0].action;
    switch (redoData[0].type) {
        case 'row': {
            switch (action) {
                case 'transaction': {
                    return { update: redoRows.previousRows };
                }
                case 'insertMultiple': {
                    let rowsToUpdate = [
                        ...(redoRows.extraRowsForPredecessor || []),
                        ...(redoRows.rolledUpRows || [])
                    ];
                    return { delete: redoRows.rowData.map((row)=>{
                        if(row.data) return row.data;
                        else row
                    }), update: rowsToUpdate };
                    // return { add: {addedRows:redoRows.rowsToAdd ,belowNodeId:redoRows.belowNodeId},update: redoRows.undoUpdatedRows};
                }
                case 'InsertCopiedData': {
                    let rowsToUpdate = [
                        ...(redoRows.extraRowsForPredecessor || []),
                        ...(redoRows.rolledUpRows || [])
                    ];
                    return { delete: redoRows.rowData.map((row)=>{
                        if(row.data) return row.data;
                        else row
                    }), update: rowsToUpdate };
                     }
                case 'delete': {
                    return { add: { addedRows: (redoRows.allRowsAdded), belowNodeId: redoRows.belowNodeId }, update: [...(redoRows.undoRowsForPredecessor || []), ...(redoRows.rolledUpRows || [])] };
                }
                case 'edit': {
                    return { update: redoRows.rowData };
                }
                case 'wrap': {
                    return { update: redoRows.cellRows };
                }
                case 'drag': {
                    return { delete: redoRows.cellRows, add: { addedRows: redoRows.cellRows, belowNodeId: redoRows.belowNodeId }, update: redoRows.updatedRows };
                }
                case 'expand' : {
                    return { update: [{...redoRows.node.data,collapsed:!redoRows.expanded}] };
                }
                case 'bulkCollapse':
                    case 'bulkExpand': {
                        return {
                            update: redoRows.node.map(node => ({
                                ...node.data,
                                collapsed: !redoRows.expanded
                            }))
                        };
                    }
                default: {
                    return {};
                }
            }
        }
        case 'column': {
            switch (action) {
                case 'delete':
                case 'updateColumnProperties': { // Merged case
                    if (redoRows.previousRows.length) {
                        return { update: redoRows.previousRows };
                    }
                    return {};
                }
                default: {
                    return {};
                }
            }
        }
        default: {
            return {}; // Return an empty object if type doesn't match
        }
    }
};


type DifferenceResult = {
    hasDifference: boolean;
    difference: gridRowChanges;
};


export function calculateDifferenceInDeltaUnits(
  obj1: gridRowChanges,
  obj2: gridRowChanges
): DifferenceResult {
  const difference: gridRowChanges = {
    add: {},
    update: {},
    delete: {},
    addedRowsBelowNodeMap: {},
  };

  // Normalize inputs
  obj1 = {
    add: obj1?.add || {},
    update: obj1?.update || {},
    delete: obj1?.delete || {},
    addedRowsBelowNodeMap: obj1?.addedRowsBelowNodeMap || {},
  };

  obj2 = {
    add: obj2?.add || {},
    update: obj2?.update || {},
    delete: obj2?.delete || {},
    addedRowsBelowNodeMap: obj2?.addedRowsBelowNodeMap || {},
  };

  // ✅ Compare 'add'
  for (const key in obj2.add) {
    if (!obj1.add[key]) {
      difference.add[key] = obj2.add[key]; // entirely new bucket
    } else {
      const newRows = obj2.add[key].filter((row2) => {
        const isPresent = obj1.add[key].find((row1) => row1.id === row2.id);

        // New row
        if (!isPresent) return true;

        // ❗ IMPORTANT: do NOT treat edits of added rows as updates
        return false;
      });

      if (newRows.length > 0) {
        difference.add[key] = newRows;
      }
    }
  }

  // ✅ Compare 'update'
  for (const key in obj2.update) {
    const isRowInAdd = Object.values(obj2.add).some((rows) =>
      rows?.some((r) => r.id === key)
    );

    // ❗ Skip updates for rows that are in add
    if (isRowInAdd) continue;

    if (
      !obj1.update[key] ||
      JSON.stringify(obj2.update[key]) !== JSON.stringify(obj1.update[key])
    ) {
      difference.update[key] = obj2.update[key];
    }
  }

  // ✅ Compare 'delete'
  for (const key in obj2.delete) {
    const isRowInAdd = Object.values(obj2.add).some((rows) =>
      rows?.some((r) => r.id === key)
    );

    // ❗ If added + deleted → ignore completely
    if (isRowInAdd) continue;

    if (
      !obj1.delete[key] ||
      JSON.stringify(obj2.delete[key]) !== JSON.stringify(obj1.delete[key])
    ) {
      difference.delete[key] = obj2.delete[key];
    }
  }

  // ✅ Compare 'addedRowsBelowNodeMap'
  for (const key in obj2.addedRowsBelowNodeMap) {
    if (
      !obj1.addedRowsBelowNodeMap[key] ||
      obj2.addedRowsBelowNodeMap[key] !== obj1.addedRowsBelowNodeMap[key]
    ) {
      difference.addedRowsBelowNodeMap[key] =
        obj2.addedRowsBelowNodeMap[key];
    }
  }

  // ✅ Final check
  const hasDifference = !Object.values(difference).every(
    (obj) => Object.keys(obj).length === 0
  );

  return { hasDifference, difference };
}

export const checkIfRollupEnabledInMDV = (mdvListData) => {
    try {
        if(typeof mdvListData === 'string'){
            mdvListData = JSON.parse(mdvListData);
        }
        if(mdvListData && mdvListData.length > 0){
            return mdvListData.some(obj => {
                const isValidPropType = obj.propType === 'date' || obj.propType === 'number';
                const isValidRollup = obj.rollup && obj.rollup !== 'None';
                return isValidPropType && isValidRollup;
              });
        }else{
            return false;
        }

    } catch (error) {
        console.error("Error in checkIfRollupEnabledInMDV", error);
    }
}

export const returnRollUpFields = (mdvListData) =>{
    try {
        if(mdvListData && mdvListData.length > 0){
            const rollUpFields = mdvListData.filter(obj => {
                const isValidPropType = obj.propType === 'date' || obj.propType === 'number';
                const isValidRollup = obj.rollup && obj.rollup !== 'none';
                return isValidPropType && isValidRollup;
            })

            return rollUpFields;
        }else{
            return mdvListData;
        }
    } catch (error) {
        console.log("Error in returnRollUpFields",error);
        
    }
}

export const returnNumberRollupFields = (mdvListData) => {
    try {
        if(mdvListData && mdvListData.length > 0){
            const rollUpFields = mdvListData.filter(obj => {
                const isValidPropType = obj.propType === 'number';
                const isValidRollup = obj.rollup && obj.rollup !== 'none';
                return isValidPropType && isValidRollup;
            })

            return rollUpFields;
        }else{
            return mdvListData;
        }
        
    } catch (error) {
        console.log("Error in returnNumberRollupFields",error);
    }
}

export const returnDateRollUpFields = (mdvListData) =>{
    try {
        if(mdvListData && mdvListData.length > 0){
            const rollUpFields = mdvListData.filter(obj => {
                const isValidPropType = obj.propType === 'date' ;
                const isValidRollup = obj.rollup && obj.rollup !== 'none';
                return isValidPropType && isValidRollup;
            })

            return rollUpFields;
        }else{
            return mdvListData;
        }
    } catch (error) {
        console.log("Error in returnRollUpFields",error);
        
    }
}

export const isHashColumn = (params)=>{
    if(params){
        return params.column.colId === '#';
    }

    return false;
}
export const getViewByOptions = (colDefs: any) => {
    const columns = colDefs||[];
    const viewOptionsArray: any[] = [];
    const viewOptionsObj: Record<string, any> = {};
  
    const acceptableTypes = [
      "dropdownsingle",
      "person",
      "assignee",
      "shareablerolluplist",
    ];
  
    const processColumn = (col: any) => {
      const type = col?.type?.toLowerCase();
      if (type && acceptableTypes.includes(type) && col?.field) {
        viewOptionsArray.push(col);
        viewOptionsObj[col.field] = col;
      }
    };
  
    columns.forEach((col: any) => {
      if (col?.groupId && Array.isArray(col?.children)) {
        col.children.forEach(processColumn);
      } else {
        processColumn(col);
      }
    });
  
    return { viewOptionsArray, viewOptionsObj };
  };
  export function flattenColumnDefs(columnDefs: any[]) {
    const columnArray: any[] = [];
    const headerNameArray: any[] = [];
  
    const seen = new Set<string>();   // prevents duplicates
  
    function traverse(col: any) {
      const { children, ...columnWithoutChildren } = col;
  
      // If group column → go deeper
      if (Array.isArray(children) && children.length > 0) {
        children.forEach(traverse);
        return;
      }
  
      const colId = columnWithoutChildren.colId || columnWithoutChildren.field;
      if (!colId) return;
  
      // Already added → skip
      if (seen.has(colId)) return;
      seen.add(colId);
  
      // Leaf column
      columnArray.push(columnWithoutChildren);
  
      if (
        colId !== "#" &&
        !columnWithoutChildren.block &&
        columnWithoutChildren.headerName
      ) {
        headerNameArray.push(columnWithoutChildren);
      }
    }
  
    columnDefs.forEach(traverse);
  
    return { columnArray, headerNameArray };
  }
  
  
  
